<template>
  <div>
    <v-data-table
      item-key="id"
      :headers="headers"
      :loading="loading"
      :items="items"
      :items-per-page="10"
      :footer-props="{'items-per-page-text': 'Số giao dịch một trang'}"
      disable-sort
      :server-items-length="count"
      v-bind="this.$attrs"
      :options.sync="pagination"
    >
      <template v-slot:[`footer.page-text`]="items">
        Giao dịch thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} giao dịch
      </template>

      <template v-slot:[`item.transactionTime`]="{item}">
        {{ item.transactionTime | getTransactionTime }}
      </template>
      <template v-slot:[`item.transactionAmount`]="{item}">
        {{ item.transactionAmount | getTransactionAmount }}
      </template>
      <template v-slot:[`item.type`]="{item}">
        {{ item.type | getType }}
        <div v-if="item.type === 'exam'" class="text-caption">(Kỳ {{ $_get(item, 'data', []).join(',') }})</div>
      </template>
      <template v-slot:[`item.status`]="{item}">
        {{ item.status | getStatus }}
      </template>
      <template v-slot:[`item.cv`]="{item}">
        <div v-if="item.type !== 'cv6' && item.type !== 'cv10'">{{ $_get(item, 'cv.code') }}</div>
        <div v-else>{{ $_get(item, 'activeCode.code') }}</div>
      </template>
      <template v-slot:[`item.actions`]="{item}">
        <v-btn @click="() => onDetailRefund(item)" color="error" icon v-if="item.refundData && item.type === 'exam'">
          <v-icon>mdi-information</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import utils from '@/plugins/utils'
import {get} from 'lodash'
import {TYPES} from './helpers'
const baseHeaders = [
  {text: 'Loại giao dịch', value: 'type'},
  {text: 'Trạng thái', value: 'status'},
  {text: 'Mã tài khoản', value: 'transactionCode'},
  {text: 'Số tiền nhận', value: 'transactionAmount'},
  {text: 'Mã tham chiếu giao dịch', value: 'transactionId'},
  {text: 'Ghi nhận lúc', value: 'transactionTime'},
  {text: 'Tài khoản tạo', value: 'userPhone'},
  {text: 'Hồ sơ đính kèm', value: 'cv'},
  {text: 'Thao tác', value: 'actions'},
]

export default {
  computed: {
    ...mapGetters('transaction', ['items', 'count']),
    ...mapGetters('auth', ['user']),
    headers() {
      return baseHeaders
    },
  },
  data: () => ({loading: false, pagination: {}}),
  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          await this.refresh((newOptions.page - 1) * newOptions.itemsPerPage, newOptions.itemsPerPage)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions({fetchItems: 'transaction/fetchItems'}),
    async refresh(_start = 0, _limit = 10) {
      this.loading = true
      await this.fetchItems({_start, _limit, _sort: 'transactionTime:DESC'})
      this.loading = false
    },
    onDetailRefund(item) {
      const refundData = get(item, 'refundData', []).map(
        i => `Kỳ ${Object.values(i)[0]} - Huỷ lúc ${moment(Number(Object.keys(i)[0])).format('DD/MM/YYYY HH:mm')}`,
      )

      this.$dialog.confirm({
        title: 'Chi tiết huỷ',
        okText: 'Đã hiểu',
        midContent: refundData.join('<br>'),
        hideCancel: true,
      })
    },
  },
  filters: {
    getTransactionTime: transactionTime => (!transactionTime ? '' : moment(transactionTime).format('DD/MM/YYYY HH:mm')),
    getTransactionAmount: amount => utils.formatMoney(amount),
    getType: type => {
      const transType = TYPES.find(i => i.value === type)
      return get(transType, 'title', '')
    },
    getStatus: status => {
      switch (status) {
        case 'pending':
          return 'Chưa thanh toán'
        case 'success':
          return 'Đã thanh toán'
        case 'canceled':
          return 'Đã huỷ'
        default:
          return ''
      }
    },
  },
}
</script>
